/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_SERVICES } from 'src/actions/dispatchServiceActions';

const initialState = {
  services: []
};

const typesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICES: {
      const services = action.payload;

      return produce(state, (draft) => {
        draft.services = services;
      });
    }

    default: {
      return state;
    }
  }
};

export default typesReducer;
